<h3>{{ formSchema?.title }}</h3>

<mat-card>
  @if (setupForm) {
    <mat-card-content>
      <form [formGroup]="setupForm">
        @if (setupForm.disabled || setupForm.valid) {
          <div class="banner form-valid">
            <mat-icon>check_circle_outline</mat-icon>
            We’ve got all the info we need here. You can still edit the values if they need adjustments.
          </div>
        }
        @if (!setupForm.disabled && !setupForm.valid) {
          <div class="banner form-invalid">
            <mat-icon>error_outline</mat-icon>
            There are mandatory fields that still need information in this section.
          </div>
        }
        <formly-form [fields]="section"
                     [model]="setupForm?.getRawValue()"
                     [form]="setupForm">
        </formly-form>
      </form>
    </mat-card-content>
  }
</mat-card>

